import { useFetchGet } from '../../../composables/useFetch'
import { Ref, computed } from 'vue'
import { KpiQuery, KpiResponse } from './Contracts'

export default function useFetchKpis(query: Ref<KpiQuery | undefined>) {
  const urlWithParams = computed(() => {
    if (!query.value) return undefined
    const urlQuery = encodeURIComponent(JSON.stringify(query.value))
    return `/iot/v1/buildingscore/kpi?query=${urlQuery}`
  })

  return useFetchGet<KpiResponse>(urlWithParams)
}
